import {
  IS_TRANSPORTER_EDIT, RESET_TRANSPORTER_PROFILE, GET_TRANSPORTERS,
  GET_TRANSPORTER_PROFILE, EDIT_TRANSPORTER_PROFILE, IMPORT_TRANSPORTER,
  DELETE_TRANSPORTER_PROFILE, SET_TRANSPORTER_INFO, RESET_TRANSPORTERS, RESET_EDIT_TRANSPORTER_PROFILE
} from '../types/transporter';
import { RESET_STATE } from '../types/global';

export interface TransporterState {
  isTransporterEdit: boolean,
  getTransporters: any,
  transporterProfile: any,
  transporterProfileDeleted: any,
  editTransporter: any,
  transporterInfo: any,
}

const INITIAL_STATE: TransporterState = {
  isTransporterEdit: false,
  transporterProfileDeleted: null,
  getTransporters: {},
  transporterProfile: {},
  editTransporter: {},
  transporterInfo: null,
};

const transporterReducer = function (state: TransporterState = INITIAL_STATE, action): TransporterState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;
    case IS_TRANSPORTER_EDIT:
      return { ...state, isTransporterEdit: action.payload };
    case RESET_TRANSPORTERS:
      return { ...state, getTransporters: {} };
    case GET_TRANSPORTERS:
      return { ...state, getTransporters: action.payload };
    case RESET_TRANSPORTER_PROFILE:
      return { ...state, transporterProfile: {} };
    case GET_TRANSPORTER_PROFILE:
      return { ...state, transporterProfile: action.payload };
    case IMPORT_TRANSPORTER:
      return { ...state, transporterProfile: action.payload };
    case DELETE_TRANSPORTER_PROFILE:
      return { ...state, transporterProfileDeleted: action.payload };
    case EDIT_TRANSPORTER_PROFILE:
      return { ...state, editTransporter: action.payload, transporterProfile: action.payload };
    case RESET_EDIT_TRANSPORTER_PROFILE:
      return { ...state, editTransporter: {} };
    case SET_TRANSPORTER_INFO:
      return { ...state, transporterInfo: action.payload };
    default:
      return state;
  }
};

export default transporterReducer;
